import api from '../api/appraisals'
import apiDirectors from '../api/directors'
import apiBrokers from '../api/brokers'
import apiNews from '../api/news'

export const actionTypes = {
	RECEIVE_DIRECTORS: 'appraisals/RECEIVE_DIRECTORS',
  RECEIVE_BROKERS: 'appraisals/RECEIVE_BROKERS',
  RECEIVE_NEWS: 'appraisals/RECEIVE_NEWS',
  RECEIVE_SERVICES: 'appraisals/RECEIVE_SERVICES',
  RECEIVE_CLIENTS: 'appraisals/RECEIVE_CLIENTS',
  SAVE_FORM_INFO: 'appraisals/SAVE_FORM_INFO',
  RECEIVE_CONFIRMATION: 'appraisals/RECEIVE_CONFIRMATION',
  RESET_FORM: 'appraisals/RESET_FORM',
  ERROR: 'appraisals/ERROR'
}

export const loadDirectorsBySector = (id) => {
  return(dispatch, getStore) => {
    apiDirectors.fetchDirectorsBySector(id)
      .then((data) => dispatch(receiveDirectors(data)))
  }
}

function receiveDirectors(APIdata) {
  return {
    type: actionTypes.RECEIVE_DIRECTORS,
    data: APIdata.data
  }
}

export const loadBrokers = (id) => {
  return(dispatch, getStore) => {
    apiBrokers.fetchBrokers(id)
      .then((data) => dispatch(receiveBrokers(data)))
  }
}

function receiveBrokers(APIdata) {
  return {
    type: actionTypes.RECEIVE_BROKERS,
    data: APIdata.data
  }
}

export const loadNewsBySector = (id) => {
  return(dispatch, getStore) => {
    apiNews.fetchNewsBySector(id)
      .then((data) => dispatch(receiveNews(data)))
  }
}

function receiveNews(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEWS,
    data: APIdata
  }
}

export const submitForm = (value) => {
  return (dispatch, getStore) => {
    dispatch(saveFormInfo(value))
    dispatch(sendContactForm())
  }
}

export const sendContactForm = () => {
  return (dispatch, getStore) => {
    var store = getStore().appraisals
    var params = store.form
    api.sendContactForm(params)
      .then((data) => {
        dispatch(receiveConfirmation(data))
      })
      .catch((err) => {
        console.error('Error: ', err)
        dispatch(error(err.join('\n')))
      })
  }
}

function saveFormInfo(data) {
  return {
    type: actionTypes.SAVE_FORM_INFO,
    data
  }
}

function receiveConfirmation(data) {
  return {
    type: actionTypes.RECEIVE_CONFIRMATION
  }
}

export const resetForm = () => {
  return {
    type: actionTypes.RESET_FORM
  }
}

function error(APIdataerr) {
  return {
    type: actionTypes.ERROR,
    error: APIdataerr
  }
}

export const loadServices = () => {
  return(dispatch, getStore) => {
    api.fetchServices()
      .then((data) => dispatch(receiveServices(data)))
  }
}

function receiveServices(APIdata) {
  return {
    type: actionTypes.RECEIVE_SERVICES,
    data: APIdata.data
  }
}

export const loadClients = () => {
  return(dispatch, getStore) => {
    api.fetchClients()
      .then((data) => dispatch(receiveClients(data)))
  }
}

function receiveClients(APIdata) {
  return {
    type: actionTypes.RECEIVE_CLIENTS,
    data: APIdata
  }
}



// WEBPACK FOOTER //
// ./src/actions/appraisals.js